import { Toaster as Sonner, toast } from 'sonner';
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';

/**
 * Rückmeldung nach einer Aktion, unten rechts. Einmal in der App einbinden.
 * Texte sachlich, ohne Ausrufezeichen: „Kunde gespeichert“.
 * (Ergänzung nach shadcn/ui, nicht im Design System.)
 */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      gap={8}
      // Über der Tab-Leiste, wenn die AppShell eine hat (--ek-unten, globals.css).
      offset={{ bottom: 'calc(var(--ek-unten, 0px) + 24px)' }}
      mobileOffset={{ bottom: 'calc(var(--ek-unten, 0px) + 16px)' }}
      icons={{
        success: <CircleCheck size={16} strokeWidth={1.75} className="text-success" />,
        error: <CircleAlert size={16} strokeWidth={1.75} className="text-danger" />,
        warning: <TriangleAlert size={16} strokeWidth={1.75} className="text-warning" />,
        info: <Info size={16} strokeWidth={1.75} className="text-info" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-[356px] items-start gap-3 rounded-lg border border-border bg-popover p-4 text-popover-foreground shadow-md font-sans',
          title: 't-body-strong',
          description: 't-small text-muted-foreground',
          icon: 'mt-0.5',
          actionButton:
            'ml-auto inline-flex h-control-sm shrink-0 items-center rounded-full bg-primary px-[11px] text-[13px] font-medium text-primary-foreground',
          cancelButton: 'ml-auto inline-flex h-control-sm shrink-0 items-center rounded-full px-[11px] text-[13px] font-medium hover:bg-accent',
        },
      }}
    />
  );
}

export { toast };
